<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-ukrainian');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0433 \u0491 \u0448 \u0449 \u0437 \u0445 \u0457 \u02bc',
                    '\u0444 \u0456 \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u0454',
                    '\u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e'
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>

